import React from 'react';
import EvidenceTab from 'Common/Components/EvidenceTab';
import CustomFieldsTab from '../CustomFieldsTab';
import TechnicalTab from '../TechnicalTab';
import GeneralTab from '../GeneralTab';
import CredentialsTab from '../CredentialsTab';

const TABS_CONTEXT = [
  {
    id: 'general',
    intlId: 'manage.detail.tab.general',
    component: <GeneralTab />
  },
  {
    id: 'technicalDetails',
    intlId: 'manage.detail.tab.technicalDetails',
    component: <TechnicalTab />
  },
  {
    id: 'evidence',
    intlId: 'manage.detail.tab.evidence',
    component: <EvidenceTab />
  },
  {
    id: 'customFields',
    intlId: 'manage.detail.tab.customAttributes',
    component: <CustomFieldsTab />
  },
  {
    id: 'credentials',
    intlId: 'manage.detail.tab.credentials',
    component: <CredentialsTab />
  }
];

export default TABS_CONTEXT;
